import { Controller } from "@hotwired/stimulus"

// CSP-safe replacement for `javascript:history.back()` inline URIs, which the
// project's strict `script-src` (no unsafe-inline) blocks silently. Wire it on
// an anchor whose href is the no-JS fallback path:
//
//   <a href="<%= root_path %>" data-controller="back" data-action="click->back#go">
//
// When JS is available the controller intercepts the click and navigates back
// through history; otherwise the anchor's href takes over.
export default class extends Controller {
  go(event) {
    // Only intercept plain left-clicks — let modifier clicks (open in new tab)
    // and non-primary buttons fall through to the anchor's href.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return
    }

    event.preventDefault()

    // history.length is 1 on a fresh tab / direct URL entry: there is nothing
    // to go back to, so honor the anchor href fallback instead.
    if (window.history.length > 1) {
      window.history.back()
    } else {
      const fallback = this.element.getAttribute("href") || "/"
      window.location.assign(fallback)
    }
  }
}
